import IpubDropdown from './src/main'

/* istanbul ignore next */
IpubDropdown.install = function(Vue) {
  Vue.component(IpubDropdown.name, IpubDropdown)
}

export default IpubDropdown
